import { render, staticRenderFns } from "./PermissionGroup.vue?vue&type=template&id=7d538ac5&scoped=true"
import script from "./PermissionGroup.vue?vue&type=script&lang=js"
export * from "./PermissionGroup.vue?vue&type=script&lang=js"
import style0 from "./PermissionGroup.vue?vue&type=style&index=0&id=7d538ac5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d538ac5",
  null
  
)

export default component.exports